// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"modalContainer__1dn5i","modalBody":"modalBody__24wZQ","aivfTransactionInfoModal":"aivfTransactionInfoModal__1-iRn"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/layers/modals/style.css
// module id = Z5MC
// module chunks = 307